import React, { FC } from 'react';

import { RootState, useSelector } from 'src/store';
import EditTracking from '../editor/EditTracking';

export const initTrackingValues = {
  tracking: {
    button: ['button'],
    bottom_left_button: ['never show'],
    bottom_right_button: ['close']
  }
};

const BasicScratchModalTracking: FC<any> = () => {
  const tracking = useSelector((state: RootState) => state.trackings.tracking);

  const style = `
    .root_tracking {
      width: 100%;
      height: 100%;

      overflow: hidden;
      position: relative;
      background: none;
    }
    
    .center_tracking {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: end;    
      gap: 30px;
      padding-bottom: 110px;
    }

    .modal_wrapper_tracking {
      width: 100%;
      padding: 2rem 0 0 0;
      display: flex;
      flex-direction: column;
      gap: 50px;
    }

    .slick_wrapper {    
      width: 100%;
      height: 12rem;
    }   
  
    .bottom_wrapper_tracking {
      width: 100%;
      height: 5rem;
      display: flex;
      flex-direction: column;
      gap: 5px;
    }
    .button_tracking {
      width: 100%;
      height: 2rem;
    }

    .edit_tracking {
      display: flex;
      align-items: center;
      justify-content: end;
    }
  }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root_tracking">
        <div className="center_tracking">
          <div className="modal_wrapper_tracking">
            <div className="edit_tracking">
              <EditTracking value={tracking?.button} type="button" />
            </div>
          </div>
          <div className="bottom_wrapper_tracking">
            <span className="button_tracking edit_tracking">
              <EditTracking
                value={tracking?.bottom_left_button}
                type="bottom_left_button"
              />
            </span>
            <span className="button_tracking edit_tracking">
              <EditTracking
                value={tracking?.bottom_right_button}
                type="bottom_right_button"
              />
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default BasicScratchModalTracking;
